import { render, staticRenderFns } from "./CampaignSelectBox.vue?vue&type=template&id=5e8ce038&scoped=true&"
import script from "./CampaignSelectBox.vue?vue&type=script&lang=js&"
export * from "./CampaignSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSelectBox.vue?vue&type=style&index=0&id=5e8ce038&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8ce038",
  null
  
)

export default component.exports